<template>
  <div class="md-layout pb-10">
    <div class="md-layout-item md-size-42 md-layout">
      <div
        class="md-layout-item md-size-100 md-layout px-0 pl-1 flex justify-between"
      >
        <div
          class="md-layout-item md-size-40 px-0 flex items-end text-[16px] font-normal"
        >
          <p class="h-[48px] leading-[50px]">
            {{
              type === "Inputter"
                ? $t("progress_report.inputter_roster")
                : $t("progress_report.reviewer_roster")
            }}
          </p>
        </div>
        <div class="md-layout-item md-size-30 px-0 flex items-center">
          <md-field class="m-0">
            <label>{{ $t("progress_report.assigned_status") }}</label>
            <md-select v-model="statusSelect.value">
              <md-option
                v-for="(item, index) in statusSelect.options"
                :value="item.id"
                :key="'status' + index"
              >
                {{ $t(item.name) }}
              </md-option>
            </md-select>
          </md-field>
        </div>
      </div>
      <div class="md-layout-item md-size-100 px-0 bg-[#e1e1e1] ">
        <md-field class="mb-0 border-b-[#f6f6f6]">
          <md-input
            class="mx-3 pl-3 rounded mb-3 bg-[#fff]"
            :placeholder="
              $t('progress_report.search_by_full_name_or_staff_code')
            "
            @input="debounceSearchKey"
          ></md-input>
        </md-field>
        <div
          class="pl-3 h-[330px] overflow-y-scroll"
          v-if="staffOpts && staffOpts.length"
        >
          <ul>
            <li
              v-for="(staff, index) in staffOpts"
              :key="'list staff' + index"
              class="pt-1 pl-2 pb-1 cursor-pointer hover:bg-[#CECECE]"
              :class="{
                'bg-[#CECECE]': getId(staff) === staffIdActivated
              }"
              @click.prevent="getListStudentAssigned(staff)"
            >
              {{ staff.full_name }}
              {{ staff.staff_code ? " - " + staff.staff_code : "" }}
            </li>
          </ul>
        </div>
        <div v-else class="w-full h-[330px]">
          <no-result class="h-full bg-[#E1E1E1] px-5 w-full"></no-result>
        </div>
      </div>
    </div>
    <div class="md-layout-item md-size-10 grid place-items-center text-center">
      <div>
        <p
          class="underline"
          :class="{ 'cursor-pointer text-[#106A74]': staffIdActivated }"
          @click.prevent="showModalAssignStudents"
        >
          {{ $t("progress_report.assign_students_to") }}
        </p>
        <p
          class="underline"
          :class="{ 'cursor-pointer text-red-500': studentIds.length }"
          @click.prevent="removeStudentAssigned"
        >
          {{ $t("progress_report.remove") }}
        </p>
        <!--        <p-->
        <!--          class="underline cursor-pointer"-->
        <!--          :class="{ 'cursor-pointer text-red-500': isBatchRemove }"-->
        <!--          @click="confirmBatchRemove"-->
        <!--        >-->
        <!--          {{ $t("progress_report.batch_remove") }}-->
        <!--        </p>-->
      </div>
    </div>
    <div class="md-layout-item md-size-42 md-layout items-end">
      <!--            <div class="md-layout-item md-size-100 p-0 flex items-center h-[48px]">-->
      <!--        <span class="h-[48px] leading-[48px] pr-6">-->
      <!--          {{ $t("progress_report.destructive_erasing_mode") }}-->
      <!--        </span>-->
      <!--        <md-switch-->
      <!--          v-model="isBatchRemove"-->
      <!--          @change="checkSwitchBatchRemove"-->
      <!--        ></md-switch>-->
      <!--            </div>-->
      <div
        v-if="studentOpts && studentOpts.length"
        class="md-layout-item md-size-100 bg-[#e1e1e1] grid place-items-center p-0"
      >
        <div class="h-[400px] w-full overflow-y-scroll">
          <div class="flex justify-between pr-2">
            <md-checkbox
              v-model="isSelectAllStudent"
              class="pl-2 m-1.5 cursor-pointer"
              @change="selectAllStudent(isSelectAllStudent)"
              ><span class="text-[#000000DE]"
                >{{ $t("progress_report.select_all") }}
              </span></md-checkbox
            ><span class="text-[#000000DE]"
              >{{ $t("common.total") }} {{ totalStudent }}</span
            >
          </div>
          <ul>
            <li
              v-for="(student, index) in studentOpts"
              :key="'list student' + index"
              class="pl-2 cursor-pointer flex items-start"
            >
              <md-checkbox
                class="m-1.5"
                v-model="studentIds"
                :value="getId(student)"
              ></md-checkbox>
              <span class="pt-1 text-[#000000DE]"
                >{{ student.full_name }}
                {{
                  student.student_code ? " - " + student.student_code : ""
                }}</span
              >
            </li>
          </ul>
          <div
            v-if="studentOpts.length > 12 && studentOpts.length < totalStudent"
            class="flex justify-center"
          >
            <a @click="loadMoreStudent" class="cursor-pointer">{{
              $t("progress_report.load_more")
            }}</a>
          </div>
        </div>
      </div>
      <div v-else class="w-full">
        <div class="bg-[#E1E1E1] pt-[51px]"></div>
        <no-result
          class="h-[350px] bg-[#E1E1E1] px-5"
          description="progress_report.select_user_on_the_left_table"
        ></no-result>
      </div>
    </div>
  </div>
</template>
<script>
import debounce from "lodash/debounce";
import { getId } from "@/helpers/utils";
import Swal from "sweetalert2";
import { DEFAULT_OPTION_ALL } from "@/constants";
export default {
  props: ["staffOpts", "studentOptsProps", "type"],
  data() {
    return {
      getId,
      isSelectAllStudent: false,
      studentIds: [],
      staffIdActivated: null,
      staffNameActived: "",
      isBatchRemove: false,
      studentOpts: [],
      totalStudent: null,
      searchKey: "",
      statusSelect: {
        value: "",
        options: [
          ...DEFAULT_OPTION_ALL,
          {
            name: "progress_report.assigned",
            id: "assigned"
          },
          {
            name: "progress_report.un_assigned",
            id: "un_assigned"
          }
        ]
      }
    };
  },
  computed: {
    debounceSearchKey() {
      const self = this;
      return debounce(function(searchKey) {
        self.searchKey = searchKey;
        self.$emit("fetchStaffOptions", searchKey, self.statusSelect.value);
        self.staffIdActivated = null;
        self.studentIds = [];
      }, 300);
    }
  },
  watch: {
    "statusSelect.value"() {
      this.$emit("fetchStaffOptions", this.searchKey, this.statusSelect.value);
      this.staffNameActived = null;
    },
    studentIds: function(newVal) {
      if (!newVal.length) return;
      this.isSelectAllStudent = newVal.length === this.studentOpts.length;
    },
    studentOptsProps: {
      deep: true,
      handler(value) {
        this.setStudentOpts(value);
      }
    }
  },
  methods: {
    loadMoreStudent() {
      const limit = this.studentOpts.length + 50;
      this.$emit("loadMoreStudent", limit);
    },
    setStudentOpts(data) {
      this.studentOpts = data.data;
      this.totalStudent = data.total;
    },
    showModalAssignStudents() {
      if (!this.staffIdActivated) return;
      const staffName = this.staffNameActived;
      this.$emit("showModalAssignStudent", staffName);
    },

    //batch remove
    checkSwitchBatchRemove() {
      if (!this.staffOpts || this.staffOpts.length === 0) {
        this.isBatchRemove = false;
      }
    },
    confirmBatchRemove() {
      if (!this.isBatchRemove) return;
      Swal.fire({
        title: this.$t("progress_report.batch_remove"),
        text: this.$t("progress_report.all_roster_wont_be_recovered"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-danger btn-fill",
        cancelButtonClass: "md-button md-secondary btn-fill",
        confirmButtonText: this.$t("progress_report.batch_remove"),
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.batchRemove();
        }
      });
    },
    batchRemove() {
      this.$emit("batchRemove");
      this.isBatchRemove = false;
      this.isSelectAllStudent = false;
    },

    getListStudentAssigned(staff) {
      this.staffIdActivated = getId(staff);
      this.staffNameActived = staff.full_name;
      const progressId = staff.progressSettingId;
      this.$emit("fetchListAssignStudent", {
        staffId: this.staffIdActivated,
        progressId
      });
    },

    selectAllStudent(isSelectAll) {
      if (!isSelectAll) {
        this.studentIds = [];
        return;
      }
      this.studentIds = this.studentOpts.map(item => getId(item));
    },

    removeStudentAssigned() {
      if (!this.studentIds.length) return;
      Swal.fire({
        title: this.$t("common.confirmation"),
        text: this.$t("setting.deleted_role_cant_be_recovered"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-danger btn-fill",
        cancelButtonClass: "md-button md-secondary btn-fill",
        confirmButtonText: this.$t("common.delete"),
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          const studentIds = this.studentIds;
          const staffIdActivated = this.staffIdActivated;
          this.$emit("removeStudent", {
            studentIds,
            staffIdActivated
          });
          this.studentIds = [];
          this.isSelectAllStudent = false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  appearance: none;
  width: 15px;
  height: 15px;
}

::-webkit-scrollbar-thumb {
  background: #afafaf;
  border-radius: 25px;
}
</style>
